
    <template>
      <section class="content element-doc">
        <h2 id="dui-hua-kuang"><a class="header-anchor" href="#dui-hua-kuang">¶</a> 对话框</h2>
<p>基础属性和使用方法参考 <a href="https://element.eleme.cn/#/zh-CN/component/dialog">element-ui </a> <code>el-dialog</code> 组件文档</p>
<h3 id="ji-chu-yong-fa"><a class="header-anchor" href="#ji-chu-yong-fa">¶</a> 基础用法</h3>
<demo-block>
        
        <template slot="source"><element-demo0 /></template>
        <template slot="highlight"><pre v-pre><code class="html">&lt;template&gt;
  &lt;div&gt;
    &lt;el-button @click=&quot;showDialog&quot;&gt;显示对话框&lt;/el-button&gt;
    &lt;sh-dialog :visible.sync=&quot;visible&quot; title=&quot;提示&quot; @confirm=&quot;onConfirm&quot; @cancel=&quot;onCancel&quot; :btnLoading.sync=&quot;btnLoading&quot;&gt;
      &lt;div class=&quot;dialog-body&quot;&gt;这是一段内容&lt;/div&gt;
    &lt;/sh-dialog&gt;
  &lt;/div&gt;
&lt;/template&gt;
&lt;script&gt;
  export default {
    data() {
      return {
        visible: false,
        btnLoading: false
      }
    },
    methods: {
      showDialog() {
        this.visible = true
      },
      onConfirm() {
        this.btnLoading = false
        console.log('confirm')
        this.visible = false
      },
      onCancel() {
        console.log('cancel')
      }
    }
  }
&lt;/script&gt;
</code></pre></template></demo-block><h3 id="wan-zheng-gong-neng"><a class="header-anchor" href="#wan-zheng-gong-neng">¶</a> 完整功能</h3>
<demo-block>
        
        <template slot="source"><element-demo1 /></template>
        <template slot="highlight"><pre v-pre><code class="html">&lt;template&gt;
  &lt;div&gt;
    &lt;el-button @click=&quot;showDialog&quot;&gt;显示对话框&lt;/el-button&gt;
    &lt;sh-dialog :visible.sync=&quot;visible&quot; title=&quot;提示&quot; @confirm=&quot;onConfirm&quot; @cancel=&quot;onCancel&quot; :btnLoading.sync=&quot;btnLoading&quot;&gt;
      &lt;div slot=&quot;title&quot;&gt;自定义标题&lt;/div&gt;
      &lt;div class=&quot;dialog-body&quot;&gt;body结构&lt;/div&gt;
      &lt;div slot=&quot;footer&quot;&gt;自定义底部,覆盖默认结构&lt;/div&gt;
    &lt;/sh-dialog&gt;
  &lt;/div&gt;
&lt;/template&gt;
&lt;script&gt;
  export default {
    data() {
      return {
        visible: false,
        btnLoading: false
      }
    },
    methods: {
      showDialog() {
        this.visible = true
      },
      onConfirm() {
        this.btnLoading = false
        console.log('confirm')
        this.visible = false
      },
      onCancel() {
        console.log('cancel')
      }
    }
  }
&lt;/script&gt;
</code></pre></template></demo-block><h3 id="zi-ding-yi-di-bu-cha-cao"><a class="header-anchor" href="#zi-ding-yi-di-bu-cha-cao">¶</a> 自定义底部插槽</h3>
<demo-block>
        
        <template slot="source"><element-demo2 /></template>
        <template slot="highlight"><pre v-pre><code class="html">&lt;template&gt;
  &lt;div&gt;
    &lt;el-button @click=&quot;showDialog&quot;&gt;显示对话框&lt;/el-button&gt;
    &lt;sh-dialog :visible.sync=&quot;visible&quot; title=&quot;提示&quot; @confirm=&quot;onConfirm&quot; @cancel=&quot;onCancel&quot; :btnLoading.sync=&quot;btnLoading&quot;&gt;
      &lt;div class=&quot;dialog-body&quot;&gt;这是一段内容&lt;/div&gt;
      &lt;div slot=&quot;footer&quot; class=&quot;footer-box&quot;&gt;自定义底部,覆盖默认结构&lt;/div&gt;
    &lt;/sh-dialog&gt;
  &lt;/div&gt;
&lt;/template&gt;
&lt;script&gt;
  export default {
    data() {
      return {
        visible: false,
        btnLoading: false
      }
    },
    methods: {
      showDialog() {
        this.visible = true
      },
      onConfirm() {
        this.btnLoading = false
        console.log('确认')
        this.visible = false
      },
      onCancel() {
        console.log('取消')
      }
    }
  }
&lt;/script&gt;
</code></pre></template></demo-block><h3 id="bu-xu-yao-di-bu"><a class="header-anchor" href="#bu-xu-yao-di-bu">¶</a> 不需要底部</h3>
<demo-block>
        
        <template slot="source"><element-demo3 /></template>
        <template slot="highlight"><pre v-pre><code class="html">&lt;template&gt;
  &lt;div&gt;
    &lt;el-button @click=&quot;showDialog&quot;&gt;显示对话框&lt;/el-button&gt;
    &lt;sh-dialog
      :visible.sync=&quot;visible&quot;
      title=&quot;提示&quot;
      @confirm=&quot;onConfirm&quot;
      @cancel=&quot;onCancel&quot;
      :btnLoading.sync=&quot;btnLoading&quot;
      :footerShow=&quot;false&quot;
    &gt;
      &lt;div class=&quot;dialog-body&quot;&gt;这是一段内容&lt;/div&gt;
    &lt;/sh-dialog&gt;
  &lt;/div&gt;
&lt;/template&gt;
&lt;script&gt;
  export default {
    data() {
      return {
        visible: false,
        btnLoading: false
      }
    },
    methods: {
      showDialog() {
        this.visible = true
      },
      onConfirm() {
        this.btnLoading = false
        console.log('confirm')
        this.visible = false
      },
      onCancel() {
        console.log('cancel')
      }
    }
  }
&lt;/script&gt;
</code></pre></template></demo-block><h3 id="shu-xing"><a class="header-anchor" href="#shu-xing">¶</a> 属性</h3>
<table>
<thead>
<tr>
<th>参数</th>
<th>说明</th>
<th>类型</th>
<th>可选值</th>
<th>默认值</th>
</tr>
</thead>
<tbody>
<tr>
<td>visible</td>
<td>是否显示对话框,支持.sync 修饰符</td>
<td>Boolean</td>
<td>-</td>
<td>false</td>
</tr>
<tr>
<td>close-on-click-modal</td>
<td>是否可以通过点击遮罩层关闭对话框</td>
<td>Boolean</td>
<td>-</td>
<td>false</td>
</tr>
<tr>
<td>confrim-text</td>
<td>确认按钮文字</td>
<td>String</td>
<td>-</td>
<td>确定</td>
</tr>
<tr>
<td>cancel-text</td>
<td>取消按钮文字</td>
<td>String</td>
<td>-</td>
<td>取消</td>
</tr>
<tr>
<td>btn-loading</td>
<td>按钮加载状态</td>
<td>Boolean</td>
<td>-</td>
<td>false</td>
</tr>
<tr>
<td>footer-show</td>
<td>是否显示底部</td>
<td>Boolean</td>
<td>-</td>
<td>true</td>
</tr>
</tbody>
</table>
<h3 id="shi-jian"><a class="header-anchor" href="#shi-jian">¶</a> 事件</h3>
<table>
<thead>
<tr>
<th>事件名</th>
<th>说明</th>
<th>参数</th>
</tr>
</thead>
<tbody>
<tr>
<td>confirm</td>
<td>点击确认按钮触发</td>
<td>-</td>
</tr>
<tr>
<td>cancel</td>
<td>点击取消按钮触发</td>
<td>-</td>
</tr>
</tbody>
</table>
<h3 id="cha-cao"><a class="header-anchor" href="#cha-cao">¶</a> 插槽</h3>
<table>
<thead>
<tr>
<th>插槽名</th>
<th>说明</th>
</tr>
</thead>
<tbody>
<tr>
<td>title</td>
<td>自定义标题结构</td>
</tr>
<tr>
<td>default</td>
<td>对话框内容</td>
</tr>
<tr>
<td>footer</td>
<td>自定义底部结构</td>
</tr>
</tbody>
</table>

      </section>
    </template>
    <script>
      export default {
        name: 'component-doc',
        components: {
          "element-demo0": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[[_c('div',[_c('el-button',{on:{"click":_vm.showDialog}},[_vm._v("显示对话框")]),_vm._v(" "),_c('sh-dialog',{attrs:{"visible":_vm.visible,"title":"提示","btnLoading":_vm.btnLoading},on:{"update:visible":function($event){_vm.visible=$event},"confirm":_vm.onConfirm,"cancel":_vm.onCancel,"update:btnLoading":function($event){_vm.btnLoading=$event},"update:btn-loading":function($event){_vm.btnLoading=$event}}},[_c('div',{staticClass:"dialog-body"},[_vm._v("这是一段内容")])])],1)]],2)}
var staticRenderFns = []

  
    const democomponentExport = {
    data() {
      return {
        visible: false,
        btnLoading: false
      }
    },
    methods: {
      showDialog() {
        this.visible = true
      },
      onConfirm() {
        this.btnLoading = false
        console.log('confirm')
        this.visible = false
      },
      onCancel() {
        console.log('cancel')
      }
    }
  }
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),"element-demo1": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[[_c('div',[_c('el-button',{on:{"click":_vm.showDialog}},[_vm._v("显示对话框")]),_vm._v(" "),_c('sh-dialog',{attrs:{"visible":_vm.visible,"title":"提示","btnLoading":_vm.btnLoading},on:{"update:visible":function($event){_vm.visible=$event},"confirm":_vm.onConfirm,"cancel":_vm.onCancel,"update:btnLoading":function($event){_vm.btnLoading=$event},"update:btn-loading":function($event){_vm.btnLoading=$event}}},[_c('div',{attrs:{"slot":"title"},slot:"title"},[_vm._v("自定义标题")]),_vm._v(" "),_c('div',{staticClass:"dialog-body"},[_vm._v("body结构")]),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_vm._v("自定义底部,覆盖默认结构")])])],1)]],2)}
var staticRenderFns = []

  
    const democomponentExport = {
    data() {
      return {
        visible: false,
        btnLoading: false
      }
    },
    methods: {
      showDialog() {
        this.visible = true
      },
      onConfirm() {
        this.btnLoading = false
        console.log('confirm')
        this.visible = false
      },
      onCancel() {
        console.log('cancel')
      }
    }
  }
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),"element-demo2": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[[_c('div',[_c('el-button',{on:{"click":_vm.showDialog}},[_vm._v("显示对话框")]),_vm._v(" "),_c('sh-dialog',{attrs:{"visible":_vm.visible,"title":"提示","btnLoading":_vm.btnLoading},on:{"update:visible":function($event){_vm.visible=$event},"confirm":_vm.onConfirm,"cancel":_vm.onCancel,"update:btnLoading":function($event){_vm.btnLoading=$event},"update:btn-loading":function($event){_vm.btnLoading=$event}}},[_c('div',{staticClass:"dialog-body"},[_vm._v("这是一段内容")]),_vm._v(" "),_c('div',{staticClass:"footer-box",attrs:{"slot":"footer"},slot:"footer"},[_vm._v("自定义底部,覆盖默认结构")])])],1)]],2)}
var staticRenderFns = []

  
    const democomponentExport = {
    data() {
      return {
        visible: false,
        btnLoading: false
      }
    },
    methods: {
      showDialog() {
        this.visible = true
      },
      onConfirm() {
        this.btnLoading = false
        console.log('确认')
        this.visible = false
      },
      onCancel() {
        console.log('取消')
      }
    }
  }
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),"element-demo3": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[[_c('div',[_c('el-button',{on:{"click":_vm.showDialog}},[_vm._v("显示对话框")]),_vm._v(" "),_c('sh-dialog',{attrs:{"visible":_vm.visible,"title":"提示","btnLoading":_vm.btnLoading,"footerShow":false},on:{"update:visible":function($event){_vm.visible=$event},"confirm":_vm.onConfirm,"cancel":_vm.onCancel,"update:btnLoading":function($event){_vm.btnLoading=$event},"update:btn-loading":function($event){_vm.btnLoading=$event}}},[_c('div',{staticClass:"dialog-body"},[_vm._v("这是一段内容")])])],1)]],2)}
var staticRenderFns = []

  
    const democomponentExport = {
    data() {
      return {
        visible: false,
        btnLoading: false
      }
    },
    methods: {
      showDialog() {
        this.visible = true
      },
      onConfirm() {
        this.btnLoading = false
        console.log('confirm')
        this.visible = false
      },
      onCancel() {
        console.log('cancel')
      }
    }
  }
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),
        }
      }
    </script>
  